module.exports = __webpack_public_path__ + "img/content-3.5fd779f5.png";